<template>
  <div class="flex-row">
    <div class="frame-1723">
      <div class="company roboto-medium-white-18px">
        {{ plan.metadata.name }}
      </div>
      <div class="price-1">
        <div class="amount">
          <div class="price-2">
            €
          </div>
          <div class="number-2">
            {{ plan.amount / 100 }}
          </div>
          <div class="number-3 roboto-medium-mountain-meadow-18px">
            00
          </div>
        </div>
      </div>
      <p class="text-33">
        Start your journey improvising the biosensors performance.
      </p>
      <div class="frame-1719">
        <div class="tick">
          <div class="overlap-group1">
            <svg
              class="vector-4"
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.5L4.5 10L13.5 1"
                stroke="#30C56F"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        <div class="text-34 worksans-normal-white-16px">
          Efficient data analysis
        </div>
      </div>
      <div class="frame-1718">
        <div class="tick">
          <div class="overlap-group1">
            <svg
              class="vector-4"
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.5L4.5 10L13.5 1"
                stroke="#30C56F"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        <p class="text-35 worksans-normal-white-16px">
          Document the results
        </p>
      </div>

      <div class="frame-1720">
        <div class="tick">
          <div class="overlap-group1">
            <svg
              class="vector-4"
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.5L4.5 10L13.5 1"
                stroke="#30C56F"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        <div class="x2-gb-cloud-storage worksans-normal-white-16px">
          Secure Cloud storage access
        </div>
      </div>
      <div class="frame-1721">
        <div class="tick">
          <div class="overlap-group1">
            <div class="ellipse-2" />
            <svg
              class="vector-4"
              width="15"
              height="12"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.5L4.5 10L13.5 1"
                stroke="#30C56F"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        <div class="secured-data worksans-normal-white-16px">
          Secured data
        </div>
      </div>
      <div class="frame-1722">
        <div class="tick">
          <div class="overlap-group1">
            <div class="ellipse-2" />
            <svg
              width="15"
              height="12"
              class="vector-4"
              viewBox="0 0 15 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.5L4.5 10L13.5 1"
                stroke="#30C56F"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        <div class="address worksans-normal-white-16px">
          Learning modules
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    plan:{
      type:Object,
      required: true
    },
  },
};
</script>

<style scoped>
.item-i43839342021 {
  color: #30c56f;
  font-family: var(--font-family-inter-regular);
  font-size: var(--font-size-m);
  font-weight: 400;
  letter-spacing: 0;
  min-height: 17px;
}



 .headerdb-regular-option-1 {
  align-items: center;
  background-color: var(--white);
  box-shadow: 0px 1px 0px #e2e8f0;
  display: flex;
  height: 60px;
  min-width: 100%;
  padding: 0 40px;
}

 .frame-1737 {
  align-items: flex-start;
  display: flex;
  min-width: 327px;
}

 .big-1 {
  height: 32px;
  object-fit: cover;
  width: 70px;
}

 .frame-1729 {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: flex-end;
  margin-left: 33px;
  min-width: 224px;
  padding: 0 6px;
}

 .dashboard {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  min-width: 87px;
  white-space: nowrap;
}

 .terminal {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 54px;
  min-height: 24px;
  min-width: 69px;
  white-space: nowrap;
}

 .icon {
  align-items: flex-end;
  display: flex;
  height: 20px;
  margin-left: 611px;
  padding: 0.8px;
  width: 20px;
}

 .overlap-group1-1 {
  height: 18px;
  margin-left: 1px;
  position: relative;
  width: 18px;
}

 .vector {
  height: 16px;
  left: 0;
  position: absolute;
  top: 0;
  width: 16px;
}

 .vector-1 {
  height: 7px;
  left: 11px;
  position: absolute;
  top: 11px;
  width: 7px;
}

 .frame-1733 {
  align-items: center;
  display: flex;
  margin-left: 23px;
  min-width: 378px;
}

 .frame-1731 {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 33px;
  justify-content: flex-end;
  min-width: 71px;
  padding: 0 6px;
}

 /* .iconshelpinactive {
  background-image: url("../../../assets/img/icons-help--inactive@2x.svg");
  background-size: 100% 100%;
  height: 16px;
  margin-bottom: 0;
  width: 16px;
} */

 .help {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 8px;
  min-height: 17px;
  min-width: 33px;
  white-space: nowrap;
}

 .frame-1736 {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: flex-end;
  margin-left: 24px;
  min-width: 135px;
}

 .ellipse-4 {
  height: 32px;
  object-fit: cover;
  width: 32px;
}

 .frame-1734 {
  align-items: center;
  display: flex;
  height: 33px;
  margin-left: 2px;
  min-width: 99px;
  padding: 0 8px;
}

 .name {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 65px;
  white-space: nowrap;
}

 .polygon-3 {
  height: 8px;
  margin-bottom: 0;
  margin-left: 7px;
  width: 10px;
}

 .frame-1732 {
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  height: 35px;
  justify-content: flex-end;
  margin-left: 24px;
  min-width: 124px;
  padding: 8px 6px;
}

 .iconsnotificationinactive {
  align-items: flex-start;
  display: flex;
  height: 19px;
  min-width: 16px;
}

 .overlap-group1-2 {
  align-items: flex-start;
  /* background-image: url("../../../assets/img/icons-notification-inactive@2x.svg"); */
  background-size: 100% 100%;
  display: flex;
  height: 20px;
  justify-content: flex-end;
  margin-top: -0.4px;
  min-width: 16px;
  padding: 2.4px 0;
}

 .ellipse-3 {
  background-color: var(--djuli-secondary-color);
  border-radius: 3.5px;
  height: 7px;
  width: 7px;
}

 .notifications {
  align-self: center;
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 8px;
  min-height: 17px;
  min-width: 86px;
  white-space: nowrap;
}

 .frame-1739 {
  align-items: flex-start;
  align-self: flex-start;
  display: flex;
  height: 20px;
  margin-left: 154px;
  margin-top: 24px;
  min-width: 192px;
}

 .item {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 42px;
  white-space: nowrap;
}

 .text-2 {
  letter-spacing: 0;
  line-height: 20px;
  margin-left: 2px;
  min-height: 20px;
  min-width: 7px;
  white-space: nowrap;
}

 .item-1 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  min-height: 17px;
  min-width: 45px;
  white-space: nowrap;
}

 .item-2 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  min-height: 17px;
  white-space: nowrap;
}

 .frame-1750 {
  align-items: center;
  display: flex;
  flex-direction: column;
  /* margin-left: 1px; */
  /* margin-top: 24px; */
  /* min-height: 70px; */
  /* width: 355px; */
  margin-top: 4rem;
}

 .text-30 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  margin-top: 8px;
  min-height: 34px;
  text-align: center;
  width: 357px;
}

 .frame-1748 {
  align-items: center;
  display: flex;
  height: 48px;
  /* margin-left: 1px; */
  margin-top: 24px;
  /* min-width: 835px; */
  /* padding: 0 8px;*/
}

 .frame-1747 {
  align-items: center;
  display: flex;
  min-width: 157px;
}

 .frame-1746-1 {
  align-items: flex-end;
  background-color: var(--djuli-tertiary-color);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 10px;
}

 .number-1 {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 9px;
  white-space: nowrap;
}

 .customise-plan {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 119px;
  white-space: nowrap;
}

 .line {
  height: 1px;
  margin-left: 40px;
  width: 40px;
}

 .frame-1748-1 {
  align-items: center;
  display: flex;
  margin-left: 40px;
  min-width: 197px;
}

 .frame-1746 {
  align-items: flex-end;
  background-color: var(--seashell);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 8px;
}

 .number {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 11px;
  white-space: nowrap;
}

 .payment-information {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 159px;
  white-space: nowrap;
}

 .frame-1749 {
  align-items: center;
  display: flex;
  margin-left: 40px;
  min-width: 225px;
}

 .text-28 {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 187px;
  white-space: nowrap;
}

 .flex-row {
  margin-top: -3rem;
}

 .frame-1723 {
  align-items: flex-start;
  background-color: var(--port-gore);
  border-radius: 16px;
  box-shadow: -8px 16px 24px #0000003d;
  display: flex;
  flex-direction: column;

  padding: 24px 0;
  width: 366px;
  margin-right: 7rem;
}

 .company {
  letter-spacing: 0;
  margin-left: 24px;
  min-height: 21px;
}

 .price-1 {
  align-items: center;
  display: flex;
  margin-left: 24px;
  margin-top: 20px;
  min-width: 155px;
}

 .amount {
  align-items: flex-start;
  display: flex;
  height: 56px;
  min-width: 85px;
}

 .price-2 {
  color: var(--djuli-primary-color);
  font-family: var(--font-family-roboto);
  font-size: var(--font-size-xxl);
  font-weight: 100;
  letter-spacing: 0;

  min-width: 29px;
}

 .number-2 {
  color: var(--djuli-primary-color);
  font-family: var(--font-family-roboto);
  font-size: var(--font-size-xxl);
  font-weight: 500;
  letter-spacing: 0;
  margin-left: 3px;
  min-height: 56px;
  min-width: 30px;
}

 .number-3 {
  letter-spacing: 0;
  margin-left: 2px;
  min-height: 21px;
}

 .month {
  color: #a8a8a8;
  font-family: var(--font-family-work_sans);
  font-size: var(--font-size-xs);
  letter-spacing: 0;
  margin-left: 8px;
  min-height: 14px;
  min-width: 49px;
}

 .text-33 {
  color: #bababa;
  font-family: var(--font-family-work_sans);
  font-size: var(--font-size-m);
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 24px;
  margin-top: 20px;
  min-height: 48px;
  width: 270px;
}

 .frame-1719 {
  align-items: flex-start;
  display: flex;
  margin-left: 24px;
  margin-top: 20px;
  min-width: 240px;
}

 .tick {
  align-items: flex-start;
  background-color: var(--saltpan);
  display: flex;
  min-width: 24px;
  border-radius: 12px !important;
}

 .overlap-group1 {
  background-color: var(--saltpan);
  border-radius: 12px !important;
  height: 24px;
  position: relative;
  width: 24px;
}

 .ellipse-2 {
  background-color: var(--saltpan);
  border-radius: 12px;
  height: 24px;
  left: 0;
  opacity: 0.12;
  position: absolute;
  top: 0;
  width: 24px;
}

 .vector-4 {
  height: 12px;
  left: 5px;
  position: absolute;
  top: 6px;
  width: 15px;
}

 .text-34 {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 16px;
  min-height: 24px;
  white-space: nowrap;
}

 .frame-1718 {
  align-items: center;
  align-self: center;
  display: flex;
  height: 48px;
  margin-right: 44px;
  margin-top: 20px;
  min-width: 274px;
}

 .text-35 {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 16px;
  width: 236px;
}

 .frame-1720 {
  align-items: flex-start;
  display: flex;
  margin-left: 24px;
  margin-top: 20px;
  min-width: 186px;
}

 .x2-gb-cloud-storage {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 16px;
  min-height: 24px;
  white-space: nowrap;
}

.x3916508 {
  border-radius: 5px;
  height: 76px;
  margin-left: 24px;
  margin-top: 20px;
  opacity: 1;
  position: relative;
  width: 280px;
}

.x3916508 .label-i39165082068-Iad5Ao {
  color: #cbd5e1;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916508-2079218 {
  background-color: #403a7c;
  border: 1px solid #4a4390;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 280px;
}

.i3916508-2079218 .input-text-here-i391-QMsEub {
  color: #f1f5f9;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}
input {
  color: #f1f5f9;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
  padding-left: 1rem;
}
input::placeholder {
  color: #f1f5f9;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.x3916509 {
  height: 20px;
  margin-left: 24px;
  margin-top: 20px;
  opacity: 1;
  position: relative;
  width: 318px;
}

.i3916509-146208 {
  height: 20px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 20px;
}

.i3916509-146208 .vector-opcufc {
  height: 18px;
  left: 1px;
  opacity: 1;
  position: absolute;
  top: 1px;
  width: 18px;
}

.x3916509 .list-item-i3916509-XS8v5y {
  color: #fb399a;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 28px;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 1px;
  white-space: nowrap;
}

 .frame-1721 {
  align-items: flex-start;
  display: flex;
  margin-left: 24px;
  margin-top: 20px;
  min-width: 144px;
}

 .secured-data {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 16px;
  min-height: 24px;
  white-space: nowrap;
}

 .frame-1722 {
  align-items: flex-start;
  display: flex;
  margin-left: 24px;
  margin-top: 20px;
  min-width: 174px;
}

 .address {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 16px;
  min-height: 24px;
  white-space: nowrap;
}

 .group-1987 {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 1px;
  width: 480px;
}

 .group-1986 {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: 2px;

  width: 482px;
}

 .frame-1755 {
  align-items: center;
  display: flex;
  margin-right: 2px;
  min-width: 464px;
}

 .business-plan-1 {
  color: var(--black);
  font-family: var(--font-family-inter);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.46px;
  line-height: 28px;
  min-height: 28px;
  min-width: 153px;
  white-space: nowrap;
}

 .cta-plate {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 12px;
  display: flex;
  height: 66px;
  margin-left: 69px;
  min-width: 242px;
  padding: 4.5px;
}

 .buttonsubscribe {
  align-items: flex-end;
  background-color: var(--djuli-primary-color);
  border-radius: 8px;
  box-shadow: 0px 16px 24px #0000001f;
  display: flex;
  height: 55px;
  justify-content: flex-end;
  min-width: 120px;
  padding: 19px 25px;
}

 .monthly {
  letter-spacing: 0;
  min-height: 16px;
  min-width: 67px;
  text-align: center;
}

 .yearly {
  align-self: center;
  letter-spacing: 0;
  margin-bottom: 1px;
  margin-left: 32px;
  min-height: 16px;
  min-width: 51px;
  text-align: center;
}

 .line-10 {
  height: 1px;
  margin-right: 1px;
  margin-top: 30px;
  width: 465px;
}

 .frame-1756 {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-right: 2px;
  margin-top: 23px;
  padding: 8px 0;
  width: 480px;
}

 .frame-1754 {
  align-items: center;
  display: flex;
  height: 87px;
  min-width: 464px;
}

 .frame-1753 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 87px;
  width: 237px;
}

 .business-plan {
  letter-spacing: 0;
  line-height: 28px;
  min-height: 28px;
  white-space: nowrap;
}

 .text-3 {
  letter-spacing: 0;
  line-height: 17px;
  margin-top: 8px;
  min-height: 51px;
  width: 239px;
  text-align: justify;
}

 .price {
  letter-spacing: -0.38px;
  line-height: 23px;
  margin-left: 173px;
  min-height: 23px;
  min-width: 56px;
  white-space: nowrap;
}

 .frame-1756-1 {
  align-items: center;
  display: flex;
  height: 87px;
  margin-top: 24px;
  min-width: 464px;
}

 .line-11 {
  height: 1px;
  margin-right: 1px;
  margin-top: 23px;
  width: 465px;
}

 .flex-row-1 {
  align-items: flex-start;
  display: flex;
  height: 28px;
  margin-left: 1px;
  margin-top: 28px;
  min-width: 467px;
}

 .subtotal {
  letter-spacing: 0;
  line-height: 28px;
  min-height: 28px;
  min-width: 82px;
  white-space: nowrap;
}

 .price-3 {
  color: var(--mirage);
  font-family: var(--font-family-inter);
  font-size: 23px;
  font-weight: 600;
  letter-spacing: -0.46px;
  line-height: 28px;
  margin-left: 308px;
  min-height: 28px;
  white-space: nowrap;
}

 .buttonsubscribe-1 {
  align-items: center;
  background-color: var(--djuli-primary-color);
  border-radius: 8px;
  box-shadow: 0px 16px 24px #0000001f;
  cursor: pointer;
  display: flex;
  height: 69px;
  justify-content: flex-end;
  margin-left: 1px;
  margin-top: 39px;
  min-width: 393px;
  padding: 0 47px;
}

 .text-38 {
  letter-spacing: 0;
  min-height: 21px;
  min-width: 297px;
  text-align: center;
}

 .overlap-group {
  align-items: center;
  background-color: #f3f3f3;
  display: flex;
  height: 93px;
  /* margin-left: 4px; */
  margin-top: 24px;
  width: 100vw;
  justify-content: space-around;
  padding: 0 246px;
}

 .frame-1758 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 49px;
  width: 327px;
}

 .text-3-1 {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  white-space: nowrap;
}

 .link {
  color: var(--djuli-primary-color);
  cursor: pointer;
  font-family: var(--font-family-inter);
  font-size: var(--font-size-m);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 8px;
  min-height: 24px;
  white-space: nowrap;
}

 .frame-1757 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-left: 247px;
  min-height: 49px;
  width: 225px;
}
/* comp-plans - 391_6508 */

.x3916508 .label-i39165082068-Iad5Ao {
  background-color: transparent;
  color: #cbd5e1;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916508-2079218 {
  background-color: #403a7c;
  border: 1px solid #4a4390;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 280px;
}

.i3916508-2079218 .input-text-here-i391-QMsEub {
  background-color: transparent;
  color: #f1f5f9;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* comp-plans - i391_6508-2079_218 */

.i3916508-2079218 .input-text-here-i391-QMsEub {
  background-color: transparent;
  color: #f1f5f9;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* comp-plans - 391_6509 */

.i3916509-146208 {
  background-color: transparent;
  height: 20px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 20px;
}

.i3916509-146208 .vector-opcufc {
  background-color: transparent;
  height: 18px;
  left: 1px;
  opacity: 1;
  position: absolute;
  top: 1px;
  width: 18px;
}

.x3916509 .list-item-i3916509-XS8v5y {
  background-color: transparent;
  color: #fb399a;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 28px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 1px;
  white-space: nowrap;
  width: auto;
}
/* comp-plans - i391_6509-146_208 */

.i3916509-146208 .vector-opcufc {
  background-color: transparent;
  height: 18px;
  left: 1px;
  opacity: 1;
  position: absolute;
  top: 1px;
  width: 18px;
}
</style>
